module.exports = __webpack_public_path__ + "img/Intellipure-950P.b89781a7.png";